import { useSyncExternalStore } from "react";
import { subscribe, getPath, getSearchParams, matchRoute } from "./lib/router.ts";
import { Layout } from "./components/Layout.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { CategoryPage } from "./pages/CategoryPage.tsx";
import { SearchResultsPage } from "./pages/SearchResultsPage.tsx";
import { AlternativesPage } from "./pages/AlternativesPage.tsx";
import "./index.css";

function useRoute() {
  const path = useSyncExternalStore(subscribe, getPath, getPath);
  return path;
}

export function App() {
  const path = useRoute();
  const searchParams = getSearchParams();

  let page: React.ReactNode;

  const categoryMatch = matchRoute("/category/:slug", path);
  const alternativeMatch = matchRoute("/alternative/:slug", path);
  if (path === "/" || path === "") {
    page = <HomePage />;
  } else if (categoryMatch) {
    page = <CategoryPage slug={categoryMatch.slug!} />;
  } else if (alternativeMatch) {
    page = <AlternativesPage slug={alternativeMatch.slug!} />;
  } else if (path === "/search") {
    const q = searchParams.get("q") ?? "";
    page = <SearchResultsPage query={q} />;
  } else {
    page = <HomePage />;
  }

  return <Layout>{page}</Layout>;
}

export default App;
